import React from "react";
import { HeartHandshake, Sprout, Salad, Users } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal } from "../motion";
import { LeafSprig } from "../Botanicals";

const icons = [HeartHandshake, Salad, Sprout, Users];

const Services = () => {
  const { t } = useLang();
  const items = t("services.items");

  return (
    <section id="services" data-testid="services" className="bg-muted text-foreground relative overflow-hidden">
      <LeafSprig className="pointer-events-none absolute bottom-6 left-4 w-20 text-primary/20 animate-sway hidden lg:block" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <Reveal>
          <div className="max-w-2xl mb-16">
            <p className="text-primary text-xs uppercase tracking-[0.25em] mb-6">{t("services.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tightest">
              {t("services.title")}
            </h2>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border rounded-3xl overflow-hidden">
          {items.map((s, i) => {
            const Icon = icons[i];
            const big = i === 0;
            return (
              <Reveal key={i} delay={i * 0.08} className={big ? "lg:row-span-2 lg:col-span-1" : ""}>
                <div className={`bg-card p-8 lg:p-10 h-full flex flex-col justify-between min-h-[240px] ${big ? "lg:min-h-[500px]" : ""} group hover:bg-muted transition-colors duration-500`}>
                  <Icon className="w-9 h-9 text-primary mb-8 group-hover:scale-110 transition-transform duration-500" strokeWidth={1.2} />
                  <div>
                    <h3 className={`font-serif text-foreground ${big ? "text-3xl lg:text-4xl" : "text-2xl"} mb-3`}>{s.t}</h3>
                    <p className="text-muted-foreground font-light leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}

          <Reveal delay={0.2}>
            <div className="relative h-full min-h-[240px] overflow-hidden">
              <img
                src="/images/nordic-landscape.jpg"
                alt="Paysage nordique · maison au toit d'herbe, fjord et fleurs jaunes"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Services;
